import { useEffect, useState } from "react"
import { usePath } from "../libs/path/PathProvider"
import { FMFile } from "../shared/FMFile"
import FileList from "../components/FileList"
import Files from "../fmanlibs/Files"
import DragAndDrop, { IUpload } from "../libs/dragdrop/DragAndDrop"
import Dirs from "../fmanlibs/Dirs"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
import { useFilesProvider } from "../fmanlibs/FilesProvider"
import usePreviewDlg from "../components/Preview/PreviewDlg"
import useUploadDlg from "../components/Upload/UploadDlg"

export default function Main(){
    const {hash} = usePath()
    const {addSnackbar} = useSnackbar()
    const {files, root} = useFilesProvider()
    const {openPreview} = usePreviewDlg()
    const {busy,showUploads,setBusy} = useUploadDlg()

    const onEnter = (e:any) => {}
    const onLeave = (e:any) => {}
    const onDrop = async (e:any) => {
        e.preventDefault()
        if (busy || !root) return
        else setBusy(true)

        let files: IUpload[];
        try { files = await DragAndDrop.getFiles(root._id, e) }
        catch(e){
            addSnackbar(e)
            return setBusy(false)
        }
        if (files.length==0) return

        const paths = Array.from(new Set(files.map(file => file.path))).sort((l,r) => l.length>r.length ? -1 : 1).filter(p => !!p)
        let didCreate = false
        for(let path of paths) try {
            if (!await Dirs.i.findPath(root._id, path)) {
                await Dirs.i.createPath(root._id, path)
                didCreate = true
            }            
        }catch(e){
            addSnackbar(e)
            return setBusy(false)
        }

        let parent:FMFile
        if (didCreate) {
            // Dirs.i.expire().get()
            parent = await Files.i.expire(root._id).get(root._id)
        }
        else parent = root

        showUploads(root, files)
    }

    useEffect(() => {
        const [_,action,fileId] = hash.split("/")
        if (action=="preview" && fileId) openPreview(fileId)
    }, [hash])

    const onOver = (e:any) => { e.preventDefault(); e.stopPropagation }

return <div id="drop" className="flex1" onDragEnter={onEnter} onDragLeave={onLeave} onDrop={onDrop} onDragOver={onOver}>
        <FileList files={files} key={root?._id}/>
    </div>
}